<div *ngIf="(data$ | async) as _data" class="d-flex flex-column justify-content-center detailsContainer">
  <div class="cardItem">
    <div class="cardItemDetails">
      <mat-icon svgIcon="circle-edit-outline" color="primary" class="mr-2"></mat-icon>
      <span [attr.data-testId]="'revision-text-' + _data.displayId" data>
        {{StaticMessage.RevisionText | staticMessage}}
      </span>
      <span [attr.data-testId]="'revision-number-' + _data.displayId" class="ml-2">{{ _data.dprDetailRevision }}</span>
    </div>
  </div>

  <div class="cardItem">
    <div class="cardItemDetails">
      <mat-icon
        [svgIcon]="_data.dprDetailLockedDate ? 'lock-outline' : 'lock-open-outline'"
        color="primary"
        class="mr-2"
      ></mat-icon>
      <span [attr.data-testId]="'lock-state-' + _data.displayId">{{_data | lockStatus}}</span>
    </div>
  </div>

  <div class="cardItem">
    <button
      data-testId="download-dpr-report"
      mat-button
      color="primary"
      (click)="downloadDprReport()"
      matTooltip="Download DPR Report"
      i18n-matTooltip="@@dpr.dprCardDetails.attrDownloadDprReport"
    >
      <mat-icon svgIcon="cloud-download-outline" color="primary" class="mr-2"></mat-icon>
      {{StaticMessage.DownloadButton | staticMessage}}
    </button>
  </div>

  <div class="cardItem">
    <button
      *ngIf="_data.isSignDprDetailsUploaded"
      mat-button
      data-testId="download-signed-report"
      color="primary"
      (click)="downloadSignedReport()"
      [disabled]="!isAppOnline"
      [matTooltipDisabled]="!isAppOnline"
      matTooltip="Download Signed DPR Report"
      i18n-matTooltip="@@dpr.dprCardDetails.attrDownloadSignedDprReport"
    >
      <mat-icon svgIcon="cloud-download-outline" color="primary" class="mr-2"></mat-icon>
      <span i18n="@@dpr.dprCardDetails.btnDownloadSignedReport">Download Signed Report</span>
    </button>
    <app-file-upload-button
      *ngIf="!_data.isSignDprDetailsUploaded"
      [uploadButtonTemplate]="uploadSignedReportButton"
      (filesChange)="onUploadSignedReport($event)"
      [isMultiple]="false"
    ></app-file-upload-button>
  </div>

  <ng-template #uploadSignedReportButton let-onAddFiles>
    <ng-container *ngLet="(_data | canUploadSignedReport : isAppOnline : canEdit) as canUploadSignedReportResult">
      <div
        [matTooltip]="_data | uploadSignedReportTooltip : isAppOnline : canEdit"
        [matTooltipDisabled]="canUploadSignedReportResult"
      >
        <button
          mat-button
          data-testId="upload-signed-report"
          color="primary"
          (click)="onAddFiles()"
          [disabled]="!canUploadSignedReportResult"
          [matTooltipDisabled]="!canUploadSignedReportResult"
          matTooltip="Upload Signed DPR Report"
          i18n-matTooltip="@@dpr.dprCardDetails.attrUploadSignedDprReport"
        >
          <mat-icon svgIcon="cloud-upload-outline" color="primary" class="mr-2"></mat-icon>
          <span i18n="@@dpr.dprCardDetails.btnUploadSignedReport">Upload Signed Report</span>
        </button>
      </div>
    </ng-container>
  </ng-template>
</div>
